import { toast } from "react-toastify";
const confirmHtml = `
  <div class="confirm-backdrop"></div>
  <div class="confirm-dialog">
     <div class="confirm-popup">
        <div class="confirm-title">confirm_title</div>
        <div class="confirm-content">confirm_text</div>
        <div class="confirm-bottom"><button class="confirm-back">Back</button><button class="confirm-ok">OK</button></div>
     </div>
  </div>
`;
const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});
export { getHeaders as headers };

export function getFormData(selector) {
  const data = {};
  const form = document.querySelector(selector);
  if (!form) return {};
  const formData = new FormData(form);

  for (const [key, value] of formData.entries()) {
    if (data[key]) {
      if (!Array.isArray(data[key])) {
        data[key] = [data[key]];
      }
      data[key].push(value);
    } else {
      data[key] = value;
    }
  }
  return data;
}
export function setSession(key, obj) {
  sessionStorage.setItem(key, JSON.stringify(obj));
};
export function getSession(key) {
  var objText = sessionStorage.getItem(key);
  if (!objText) objText = "{}";
  const obj = JSON.parse(objText);
  return obj;
};
export function getLocalStorage(key) {
  var objText = localStorage.getItem(key);
  if (!objText) objText = "{}";
  const obj = JSON.parse(objText);
  return obj;
};
export function setLocalStorage(key, obj) {
  localStorage.setItem(key, JSON.stringify(obj));
};
export function getBackLink(defaultValue) {
  const queryObject = Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]).entries());
  if (queryObject.back) return queryObject.back;
  return defaultValue;
};
const VN_TIME_ZONE = 'Asia/Ho_Chi_Minh';

function vnDateParts(date) {
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: VN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(parsedDate);
  const read = (type) => parts.find((part) => part.type === type)?.value ?? '';
  return {
    day: read('day'),
    month: read('month'),
    year: read('year'),
    hour: read('hour'),
    minute: read('minute'),
    second: read('second'),
  };
}

export function formatDate(date, locale = 'vi-VN') {
  if (!date) return 'N/A';

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return 'N/A';

  return new Intl.DateTimeFormat(locale, { timeZone: VN_TIME_ZONE }).format(parsedDate);
};
export function formatDate2(date) {
  if (!date) return 'N/A';

  const parts = vnDateParts(date);
  if (!parts) return 'N/A';

  return `${parts.day}-${parts.month}-${parts.year}`;
}

/** dd-mm (không năm). */
export function formatDateDayMonth(date) {
  if (!date) return '—';

  const parts = vnDateParts(date);
  if (!parts) return '—';

  return `${parts.day}-${parts.month}`;
}

export function formatTimeShort(date, locale = 'vi-VN') {
  if (!date) return 'N/A';

  const parts = vnDateParts(date);
  if (!parts) return 'N/A';

  return `${parts.day}-${parts.month} ${parts.hour}:${parts.minute}`;
};
export function formatDateTime(date: Date | string | null | undefined): string {
  if (!date) return 'N/A';

  const parts = vnDateParts(date);
  if (!parts) return 'N/A';

  return `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}`;
};
export function formatDateTime2(date: Date | string | null | undefined) {
  if (!date) return 'N/A';

  const parts = vnDateParts(date);
  if (!parts) return 'N/A';

  return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}`;
};
export function formatDateTime3(date: Date | string | null | undefined) {
  if (!date) return 'N/A';

  const parts = vnDateParts(date);
  if (!parts) return 'N/A';

  return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`;
};
export function formatSelect3(text) {
  if (!text) return '';
  var listItems = text.replaceAll('; ', ';').split(';');
  var result = '';
  for (var i = 0; i < listItems.length; i++) {
    result += '<span class="select3-item">' + listItems[i] + '</span>';
  }
  return result;
};
export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string' && isNaN(Number(value.replace(/,/g, '')))) {
    return value;
  }
  const num = typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;
  if (isNaN(num) || num === 0) return '';

  const intPart = num >= 0 ? Math.floor(num) : Math.ceil(num);
  return intPart.toLocaleString('vi-VN');
};
/** Giống formatNumber nhưng giữ phần thập phân (tối đa 10 số để bỏ sai số dấu phẩy động). */
export function formatNumberFull(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string' && isNaN(Number(value.replace(/,/g, '')))) {
    return value;
  }
  const num = typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;
  if (isNaN(num) || num === 0) return '';

  return num.toLocaleString('vi-VN', { maximumFractionDigits: 10 });
};
export function formatDecimal(value: number | string, decimalDigits = 2): string {
  if (value === null || value === undefined || value === '') return '';

  const raw = typeof value === 'string' ? value.replace(/,/g, '') : value;
  const num = Number(raw);

  if (isNaN(num)) return String(value);
  if (num === 0) return '';

  const decimalPart = Math.abs(num % 1);

  let fractionDigits = 0;


  if (decimalPart !== 0) {
    const oneDigit = Number(decimalPart.toFixed(1));
    const twoDigits = Number(decimalPart.toFixed(2));

    if (twoDigits * 10 % 10 === 0) {
      fractionDigits = 1; // VD: .50 → hiển thị 1 số
    } else {
      fractionDigits = 2; // VD: .56 → hiển thị 2 số
    }
  }

  return num.toLocaleString('vi-VN', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatKgM3(kg, m3, sparate = " : ") {

  if (!kg || !m3) sparate = '';
  var kgText = '';
  var m3Text = '';
  if (kg) {
    kgText = formatDecimal(kg) + ' kg';
  }
  if (m3) {
    m3Text = formatDecimal(m3) + ' m3';
  }
  var result = kgText + sparate + m3Text;
  return result;
}
export function mergeText(text1, text2) {
  return [text1, text2].filter(Boolean).join('; ');
}
export function openConfirm(callback, content, title) {
  if (!title) title = 'Xác nhận';
  if (!content) content = 'Bạn có chắc chắn muốn xóa mục này không?';
  var popupHtml = confirmHtml.replace('confirm_title', title).replace('confirm_text', content);
  document.body.insertAdjacentHTML("beforeend", popupHtml);

  var okButton = document.querySelector('.confirm-ok');
  okButton.onclick = function () {
    callback();
    document.querySelectorAll('.confirm-dialog, .confirm-backdrop').forEach((item) => { item.remove(); });
  };

  var backButton = document.querySelector('.confirm-back');
  backButton.onclick = function () {
    document.querySelectorAll('.confirm-dialog, .confirm-backdrop').forEach((item) => { item.remove(); });
  };
};
export function showFormError(formSelector, model) {
  var inputTag = document.querySelector(formSelector + ' [name="' + model.name + '"]');
  var groupTag = document.querySelector(formSelector);
  if (inputTag) {
    const borderTag = inputTag.closest('.filter-ib') || inputTag;
    groupTag = borderTag.parentElement;
  }
  var errorTag = groupTag.querySelector('.error-msg');
  if (!errorTag) {
    errorTag = document.createElement('div');
    errorTag.className = 'error-msg';
    errorTag.style.color = 'red';
    groupTag.appendChild(errorTag);
  }
  errorTag.textContent = model.message;
};
export function pushUrl(url) {
  var historyText = sessionStorage.getItem('url_history');
  if (!historyText) historyText = "[]";
  const list = JSON.parse(historyText);
  if (list.length > 0) {
    var lastItem = list[list.length - 1];
    if (lastItem === url) return;
  }
  if (list.length > 10) {
    list.shift();
  }
  list.push(url);
  sessionStorage.setItem('url_history', JSON.stringify(list));
};
export function popUrl() {
  var historyText = sessionStorage.getItem('url_history');
  if (!historyText) historyText = "[]";
  var lastItem = "/";
  const list = JSON.parse(historyText);
  if (list.length > 1) {
    lastItem = list[list.length - 2];
    list.pop();
    list.pop();
  }
  sessionStorage.setItem('url_history', JSON.stringify(list));
  return lastItem;
};

export function isNumber(str) {
  return /^\d+$/.test(str);
}
export function getProductTypeText(value) {
  var text = value;
  if (value === "personal") text = "Cá nhân";
  if (value === "share") text = "Dùng chung";

  return text;
};

export function clearUrlParam() {
  const hash = window.location.hash;

  if (hash.includes('?')) {
    const cleanHash = hash.split('?')[0];
    const newUrl = window.location.origin + window.location.pathname + cleanHash;
    window.history.replaceState(null, '', newUrl);
  }
}

export async function downloadFile(requestApi, fileName) {
  try {
    const response = await fetch(requestApi, {
      method: 'GET',
      headers: getHeaders()
    });

    if (response.status === 500 && !response.statusText) {
      toast.error("500 Internal Server Error");
      return;
    }
    if (!response.ok) {
      const contentType = response.headers.get('content-type') || '';
      let errorMessage = `Lỗi ${response.status}`;
      if (contentType.includes('application/json')) {
        const errorBody = await response.json();
        errorMessage = errorBody.message || errorMessage;
      } else {
        const errorText = await response.text();
        if (errorText) errorMessage = errorText;
      }
      toast.error(errorMessage);
      return;
    }

    const blob = await response.blob();
    if (blob.size > 0) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName; // Tên file khi lưu
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    toast.error(error.message);
    console.log(error);
  }
};
